import { render } from "./TaskListTour.vue?vue&type=template&id=63ff3262"
import script from "./TaskListTour.vue?vue&type=script&lang=js"
export * from "./TaskListTour.vue?vue&type=script&lang=js"

import "./TaskListTour.vue?vue&type=style&index=0&id=63ff3262&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__